import dayjs, { Dayjs } from "dayjs";
import utc from 'dayjs/plugin/utc';
import moment from "moment";

dayjs.extend(utc);
const currentDate = dayjs().format("YYYY-MM-DD");
export const isTimeInRange = (
  startTime: string,
  endTime: string,
  selectedTime: any,
  type: string,
  endDate?: string | undefined,
  newEndDate?: string | undefined | Dayjs,
  booking_type?: string | undefined,
  selectedStartDateAndTime?: string | undefined
) => {
  const selectedStartTime = dayjs(selectedStartDateAndTime).format("HH:mm")
  const selectedStartDate = dayjs(selectedStartDateAndTime).format("YYYY-MM-DD")
  const formattedNewEndDate = dayjs(newEndDate).format("YYYY-MM-DD")

  if (type === "startTime") {
    if (startTime < endTime) {
      return selectedTime >= startTime && selectedTime <= endTime
    } else {
      return selectedTime >= startTime || selectedTime <= endTime
    }
  } else if (booking_type === "Multiple Booking") {
    if (selectedStartDate === endDate) {
      if (startTime < endTime) {
        return selectedTime >= startTime && selectedTime <= endTime
      } else {
        return selectedTime >= startTime || selectedTime <= endTime;
      }
    } else {
      if (startTime < endTime) {
        return selectedTime >= selectedStartTime && selectedTime <= endTime
      } else {
        return selectedTime <= endTime || selectedTime >= selectedStartTime;
      }
    }
  } else {
    if (endDate !== formattedNewEndDate) {
      if (selectedStartTime < startTime) {
        return (selectedTime >= selectedStartTime && selectedTime <= endTime)
      } else {
        return (selectedTime >= startTime);
      }
    } else {
      if (startTime < endTime) {
        return selectedTime >= startTime && selectedTime <= endTime
      } else {
        return selectedTime <= endTime;
      }
    }
  }
}

export const isTimeInSlot = (startTime: string, endTime: string | undefined, slotHours: string,
  startDate: string,
  endDate: string,
  actualStartTime: string,
  actualEndTime: string
) => {
  const slot: any = slotHours.toString();
  const newStartTime = dayjs(startDate);
  const newEndTime = newStartTime?.add(slot, "hour");
  const selectedEndTime = dayjs(currentDate + " " + endTime).format("HH:mm");
  const newStartDate = dayjs(startDate).format("HH:mm")
  if (dayjs(startDate).format("YYYY-MM-DD") === dayjs(newEndTime).format("YYYY-MM-DD")) {
    return dayjs(newEndTime).format("HH:mm") >= selectedEndTime && dayjs(newStartTime).format("HH:mm") <= selectedEndTime
  } else {
    if (dayjs(startDate).format("YYYY-MM-DD") === endDate) {
      return selectedEndTime >= newStartDate
    } else {
      if (actualStartTime > actualEndTime) {
        return dayjs(newEndTime).format("HH:mm") >= selectedEndTime || selectedEndTime >= startTime
      } else {
        return (selectedEndTime <= actualEndTime && selectedEndTime >= startTime)
      }
    }
  }
};

export const addHoursToTime = (startDate: string, startTime: string, hoursToAdd: string) => {
  const slot: any = hoursToAdd?.toString();
  const startTimeMoment = dayjs(startDate + " " + startTime);
  const newTimeMoment = startTimeMoment.add(slot, 'hours');
  const newTimeString = newTimeMoment.format("YYYY-MM-DD HH:mm");
  return dayjs(newTimeString);
}
export const maxDateToAllow = (startDate: string, daysToAdd: number) => {
  const date = dayjs(startDate);
  const newDate = date.add(daysToAdd, 'day');
  return newDate;
}
export const eventDateConveter = (startTime: string, endTime: string) => {
  const startDateTime = new Date(startTime);
  const endDateTime = new Date(endTime);
  const sTime = dayjs(startTime).format("HH:mm")
  const eTime = dayjs(endTime).format("HH:mm")
  const events = [];
  if (sTime > eTime) {
    // 2 Day logic
    let currentStartTime = new Date(startTime);
    let currentEndTime = new Date(endTime);
    while (currentStartTime < currentEndTime) {
      const nextDayStartTime = new Date(currentStartTime);
      nextDayStartTime.setDate(nextDayStartTime.getDate() + 1);
      const nextDayEndTime = new Date(nextDayStartTime);
      nextDayEndTime.setHours(currentEndTime.getHours());
      nextDayEndTime.setMinutes(currentEndTime.getMinutes());
      const utcStartEvent = dayjs.utc(currentStartTime)
      const utcEndEvent = dayjs.utc(nextDayEndTime)
      events.push({
        start_event: utcStartEvent.format(),
        end_event: utcEndEvent.format(),
      });
      currentStartTime = nextDayStartTime;
    }
    return events;
  } else {
    // 1 Day logic
    while (startDateTime < endDateTime) {
      const endOfCurrentDay = new Date(
        startDateTime.getFullYear(),
        startDateTime.getMonth(),
        startDateTime.getDate(),
        endDateTime.getHours(),
        endDateTime.getMinutes()
      );
      const utcStartEvent = dayjs.utc(startDateTime)
      const utcEndEvent = dayjs.utc(endOfCurrentDay)
      events.push({ start_event: utcStartEvent.format(), end_event: utcEndEvent.format() });
      startDateTime.setDate(startDateTime.getDate() + 1);
    }
    return events;
  }
}

export const isVenueTimeInRange = (startDuration: string, endDuration: string, slot: any) => {
  if (endDuration) {

    const startTime = dayjs(startDuration).format("HH:mm")
    const endTime = dayjs(endDuration).format("HH:mm")
    const duration = slot * 60

    const [startHour, startMinute] = startTime.split(':').map(Number);

    const totalStartMinutes = startHour * 60 + startMinute;
    const totalEndMinutes = totalStartMinutes + duration;

    const endHour = Math.floor(totalEndMinutes / 60) % 24;
    const endMinute = totalEndMinutes % 60;

    const endDateTime = `${endHour.toString().padStart(2, '0')}:${endMinute.toString().padStart(2, '0')}`;

    if (startTime > endDateTime) {
      // for multiple day
      return endTime <= startTime && endTime >= endDateTime
    } else {
      // for same day
      return endTime >= endDateTime || endTime <= startTime
    }
  }
}

export const convertToISOFormat = (inputDate: string) => {
  if (inputDate) {
    const [datePart, timePart] = inputDate?.split(" ");
    const [hour, minute] = timePart?.split(":");
    const isPM = /pm/i.test(inputDate);

    let convertedHour = parseInt(hour, 10);

    if (isPM && convertedHour !== 12) {
      convertedHour += 12;
    } else if (!isPM && convertedHour === 12) {
      convertedHour = 0;
    }
    const isoDateString = `${datePart}T${String(convertedHour).padStart(
      2,
      "0"
    )}:${minute}:00`;
    return moment(isoDateString).format("hh:mm a");
  }
};

export const convertToISOFormat2 = (inputDate: string) => {
  if (inputDate) {
    const [datePart, timePart] = inputDate?.split(" ");
    const [hour, minute] = timePart?.split(":");
    const isPM = /pm/i.test(inputDate);

    let convertedHour = parseInt(hour, 10);

    if (isPM && convertedHour !== 12) {
      convertedHour += 12;
    } else if (!isPM && convertedHour === 12) {
      convertedHour = 0;
    }
    const isoDateString = `${datePart}T${String(convertedHour).padStart(
      2,
      "0"
    )}:${minute}:00`;
    return isoDateString;
  }
};

export const isEndTimeValid = (startTime: string | undefined, endTime: string) => {
  //@ts-ignore
  const startDate: Date = new Date(
    //@ts-ignore
    convertToISOFormat2(`2000-01-01 ${startTime}`)
  );
  //@ts-ignore
  const endDate: Date = new Date(
    //@ts-ignore
    convertToISOFormat2(`2000-01-01 ${endTime}`)
  );
  //@ts-ignore
  if (!isNaN(startDate) && !isNaN(endDate)) {
    if (endDate?.getTime() >= startDate?.getTime()) {
      return true;
    } else {
      return false;
    }
  }
};

export const getAvatarInitials = (firstName: string, lastName: string) => {
  if (firstName && lastName) {
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  } else if (firstName) {
    return firstName.charAt(0).toUpperCase();
  } else if (lastName) {
    return lastName.charAt(0).toUpperCase();
  } else {
    return '';
  }
}